import { render, staticRenderFns } from "./UserActionButton.vue?vue&type=template&id=113248f0"
import script from "./UserActionButton.vue?vue&type=script&lang=ts"
export * from "./UserActionButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports